export const FILTER = 'FILTER';
export const ROUTING = 'ROUTING';

export const AUTH = {
  AUTH_COOKIE_KEY: 'AUTH_COOKIE_KEY',
  LOGIN_USER: 'LOGIN_USER',
  LOGOUT: 'LOGOUT',
};

export const NEO = {
  GET_NEOS: 'GET_NEOS',
};



// WEBPACK FOOTER //
// ./src/actions/types.js